<div class="global-error-container">
  <div class="error-content">
    <h1>Oops! Something went wrong.</h1>
    <p>An unexpected error has occurred. Please try refreshing the page.</p>

    @if (error(); as err) {
      @if (isDevMode) {
        <div class="error-details">
          <h2>Error Details (Developer Mode):</h2>
          <p><strong>Message:</strong> {{ err.message }}</p>
          @if (err.apiName) {
            <p><strong>API:</strong> {{ err.apiName }}</p>
          }
          @if (err.stack) {
            <h3>Stack Trace:</h3>
            <pre>{{ err.stack }}</pre>
          }
        </div>
      }
    }

    <button
      mat-flat-button
      (click)="refreshPage()">
      Refresh Page
    </button>
  </div>
</div>
